import { render, staticRenderFns } from "./anomalia.vue?vue&type=template&id=0cc0d4a9"
import script from "./anomalia.vue?vue&type=script&lang=js"
export * from "./anomalia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc0d4a9')) {
      api.createRecord('0cc0d4a9', component.options)
    } else {
      api.reload('0cc0d4a9', component.options)
    }
    module.hot.accept("./anomalia.vue?vue&type=template&id=0cc0d4a9", function () {
      api.rerender('0cc0d4a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/anomalia.vue"
export default component.exports